module.exports = __webpack_public_path__ + "img/final.35b43254.png";